<template>
  <div v-if="loading" class="text-center" style="margin-top: 10em">
    <div class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div v-else>
    <transition appear name="slide-fade">
      <div v-if="session.usuario.perfil == 0" class="row mt-5">
        <div class="col-lg-4">
          <router-link to="/aliados">
            <div class="card" style="background-color: #000">
              <div class="card-body">
                <div class="row">
                  <div class="col-auto">
                    <div class="stat stat-white text-orange">
                      <i class="align-middle bx bx-store bx-sm"></i>
                    </div>
                  </div>
                  <div class="col mt-0">
                    <h4 class="text-white mt-2">
                      Aliados
                      <div class="float-end">
                        <span class="badge bg-primary rounded-pill">
                          {{ total_aliados }}
                        </span>
                      </div>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
          <router-link to="/usuarios">
            <div class="card" style="background-color: #000">
              <div class="card-body">
                <div class="row">
                  <div class="col-auto">
                    <div class="stat stat-white text-orange">
                      <i class="align-middle bx bx-credit-card-front bx-sm"></i>
                    </div>
                  </div>
                  <div class="col mt-0">
                    <h4 class="text-white mt-2">
                      Usuarios
                      <div class="float-end">
                        <span class="badge bg-primary rounded-pill">
                          {{ total_usuarios }}
                        </span>
                      </div>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
          <router-link to="/marketing">
            <div class="card" style="background-color: #000">
              <div class="card-body">
                <div class="row">
                  <div class="col-auto">
                    <div class="stat stat-white text-orange">
                      <i class="align-middle bx bxs-component bx-sm"></i>
                    </div>
                  </div>
                  <div class="col mt-0">
                    <h4 class="text-white mt-2">Marketing</h4>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
          <router-link to="/agentes">
            <div class="card" style="background-color: #000">
              <div class="card-body">
                <div class="row">
                  <div class="col-auto">
                    <div class="stat stat-white text-orange">
                      <i class="align-middle bx bx-user-voice bx-sm"></i>
                    </div>
                  </div>
                  <div class="col mt-0">
                    <h4 class="text-white mt-2">Agentes</h4>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-lg-8"></div>
      </div>
      <div v-if="session.usuario.perfil == 1" class="row mt-5">
        <div class="col-lg-4">
          <router-link to="/aliados">
            <div class="card" style="background-color: #000">
              <div class="card-body">
                <div class="row">
                  <div class="col-auto">
                    <div class="stat stat-white text-orange">
                      <i class="align-middle bx bx-store bx-sm"></i>
                    </div>
                  </div>
                  <div class="col mt-0">
                    <h4 class="text-white mt-2">
                      Aliados
                      <div class="float-end">
                        <span class="badge bg-primary rounded-pill">
                          {{ total_aliados }}
                        </span>
                      </div>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
          <router-link to="/nueva_membresia">
            <div class="card" style="background-color: #000">
              <div class="card-body">
                <div class="row">
                  <div class="col-auto">
                    <div class="stat stat-white text-orange">
                      <i class="align-middle bx bx-credit-card-front bx-sm"></i>
                    </div>
                  </div>
                  <div class="col mt-0">
                    <h4 class="text-white mt-2">
                      <i class="bx bx-plus-circle"></i>
                      Membresía
                      <div class="float-end">
                        <span class="badge bg-primary rounded-pill">
                          {{ total_usuarios }}
                        </span>
                      </div>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-lg-8"></div>
      </div>
      <div v-if="session.usuario.perfil == 4" class="row mt-5">
        <div class="col-lg-4">
          <router-link to="/aliados">
            <div class="card" style="background-color: #000">
              <div class="card-body">
                <div class="row">
                  <div class="col-auto">
                    <div class="stat stat-white text-orange">
                      <i class="align-middle bx bx-store bx-sm"></i>
                    </div>
                  </div>
                  <div class="col mt-0">
                    <h4 class="text-white mt-2">
                      Aliados
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-lg-8"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Dashboard",
  metaInfo: {
    title: "Inicio - Reddy Backoffice",
  },
  data() {
    return {
      loading: true,
      total_aliados: 0,
      total_usuarios: 0,
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.get_resumen_aliados();
    this.get_resumen_usuarios();
  },
  methods: {
    get_resumen_aliados: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {},
      };
      axios
        .get(this.$base_url + "aliados/resumen_aliados", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.total_aliados = response.data.data.total;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_resumen_usuarios: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {},
      };
      axios
        .get(this.$base_url + "clientes/resumen_clientes", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.total_usuarios = response.data.data.total_usuarios;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    set_logout: function () {
      localStorage.removeItem("sess_reddy_back");
      location.reload();
    },
  },
  mounted: function () {
    this.loading = false;
  },
};
</script>